import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-confirm-draft',
  templateUrl: './confirm-draft.component.html',
  styleUrls: ['./confirm-draft.component.scss']
})
export class ConfirmDraftComponent implements OnInit {
  public title: string;
  public message: string;
  public confirmText: string;
  public cancelText: string;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<ConfirmDraftComponent>
  ) {
    this.title = data?.title || 'Confirmation';
    this.message = data?.message || 'Are you sure?';
    this.confirmText = data?.confirmText || 'Yes';
    this.cancelText = data?.cancelText || 'No';
  }

  ngOnInit(): void {}

  onConfirm() {
    this.dialogRef.close(true);
  }

  onCancel() {
    this.dialogRef.close(false);
  }
}
